import { render, staticRenderFns } from "./Withdrawalrecords.vue?vue&type=template&id=06931a73&scoped=true&"
import script from "./Withdrawalrecords.vue?vue&type=script&lang=js&"
export * from "./Withdrawalrecords.vue?vue&type=script&lang=js&"
import style0 from "./Withdrawalrecords.vue?vue&type=style&index=0&id=06931a73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06931a73",
  null
  
)

export default component.exports